import { utcParse } from "d3-time-format";
import i18next from "../global/LocalizedStrings"

const baseUrl = "https://api.chartgame.net/v1";


function parseData(parse) {
    return function (d) {
        d.date = parse(d.date);
        d.open = +d.open;
        d.high = +d.high;
        d.low = +d.low;
        d.close = +d.close;
        d.volume = +d.volume;

        return d;
    };
}

const parseDate = utcParse("%Y-%m-%d");

export const getData = async () => {

    const _country = i18next.t('country')

    try {
        return require(`../asset/stock_data/${_country}.json`)
    } catch (error) {
        return require(`../asset/stock_data/usa.json`)
    }

    // if (_country == 'kor') {
    //     return require('../asset/stock_data/kor.json')
    // }

    // const t = require(`../asset/stock_data/${_country}.json`)
    // console.log(t)

    // const url = baseUrl + "/company/price_data_for_web"
    // // const _country = i18next.t('country')

    // const param = {
    //     country: _country,
    // }

    // const response = await fetch(url, {
    //     method: 'POST',
    //     headers: {
    //         'Accept': 'application/json',
    //         'Content-Type': 'application/json'
    //     },
    //     body: JSON.stringify(param)
    // })

    // const result = await response.json()
    // console.log(result)
    // return result
}

// export function getData() {
//     const promiseMSFT = fetch("https://cdn.rawgit.com/rrag/react-stockcharts/master/docs/data/MSFT.tsv")
//         .then(response => response.text())
//         .then(data => tsvParse(data, parseData(parseDate)))
//     return promiseMSFT;
// }